import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import { withResizeDetector } from 'react-resize-detector/build/withPolyfill';
import ConversationStore from '../stores/ConversationStore';
import MessagesSection from './messages/MessagesSection.react';
import ConversationsSection from './conversations/ConversationsSection.react';
import responsiveness from '../../../../../sass/foundation/variables/responsiveness.scss';

const ReactPropTypes = PropTypes;
function getStateFromStores() {
  const conversationsEmpty = ConversationStore.getConversationsEmpty();

  return {
    show: !conversationsEmpty,
  };
}

class MessagesApp extends React.Component {
  static propTypes = {

};

  static defaultProps = {
    disableAutoHeight: false,
  };

  state = getStateFromStores();

  componentDidMount() {
    ConversationStore.addChangeListener(this._onChange);
  }

  componentWillUnmount() {
    ConversationStore.removeChangeListener(this._onChange);
  }

  render() {
    if (!this.state.show) {
      return (<div className="block mtl pam tac">{get(translations, 'txt: Tava vēstuļu sadaļa ir tukša', '')}</div>);
    }

    const mobile = get(globals, 'responsive', false) && window.innerWidth <= responsiveness.breakpoint;

    return (
      <div className="messages">
        <ConversationsSection mobile={mobile} />
        <div className="messages-main">
          <MessagesSection mobile={mobile} disableAutoHeight={this.props.disableAutoHeight} id="full" />
        </div>
      </div>
    );
  }

  /**
  * Event handler for 'change' events coming from the stores
  */
  _onChange = () => {
    this.setState(getStateFromStores());
  };
}

module.exports = withResizeDetector(MessagesApp);
